var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingAlphabeticalDescending = function SvgDataSortingAlphabeticalDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2v2h4L4 8.563V10h7V8H7l4-4.58V2H4Zm12 0v16h-3l4 4 4-4h-3V2h-2ZM6.8 13 4 21h2l.365-1h2.266L9 21h2l-2.8-8H6.8Zm.747 3.264L8.067 18H6.933l.613-1.736Z"
  })));
};
export default SvgDataSortingAlphabeticalDescending;